var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 427 427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "power-off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236,197V21S234,0,215,0s-23,18-23,18V197s0,18,21,18S236,197,236,197Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.1,43.94A21.83,21.83,0,0,0,320.5,78.5h-.05l1.65,2.37h0c48.35,39.64,74.69,105.16,57.74,175.2-15.28,63.09-65.94,111.74-129.48,125.05C139.78,404.31,42,320.12,42,213.5a171.26,171.26,0,0,1,64.58-134h-.08A22.29,22.29,0,0,0,81.17,46.06,213.26,213.26,0,0,0,0,212.5C-.53,328.63,92.87,424.54,209,427c119.78,2.49,218-94.23,218-213.45A213.28,213.28,0,0,0,343.1,43.94Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.755e487ead746e4772421e4548255fb8.svg";
export { ForwardRef as ReactComponent };